import { render, staticRenderFns } from "./MachineDetailScreen.vue?vue&type=template&id=366974c4"
import script from "./MachineDetailScreen.vue?vue&type=script&lang=js"
export * from "./MachineDetailScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports